import React from "react";
import { injectIntl } from "react-intl";
import { action, extendObservable } from "mobx";
import { observer } from "mobx-react";
import { Row, Col, Panel, Button, ControlLabel } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import LanesNotesFilter from "./LanesNotesFilter";
import NoteSearch from "./NoteSearch";
import NoteBodyText from "./NoteBodyText";

@withRouter
@observer
class Options extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    extendObservable(this, {
      showPanel: false,
      searchNotes: []
    });
  }

  render() {
    const { intl } = this.props;

    return (
      <div className="options-container">
        <div style={{ textAlign: "center", paddingTop: "15px" }}>
          <Button onClick={this.togglePanel} style={{ width: "125px" }}>
            {intl.formatMessage({ id: "options" })}
          </Button>
        </div>

        {this.showPanel && (
          <Row>
            <Col xs={12}>
              <Panel style={{ marginTop: "25px" }} className="arrow-box">
                <div className="centered" style={{ marginTop: "10px" }}>
                  <div>
                    <ControlLabel style={{ width: "115px" }}>
                      <i className="fa fa-filter" />
                      &nbsp;
                      {intl.formatMessage({ id: "filter_tasks" })}
                    </ControlLabel>
                    &nbsp;
                    <LanesNotesFilter
                      style={{ width: "35%", display: "inline-block" }}
                    />
                  </div>

                  <div>
                    <ControlLabel style={{ width: "115px" }}>
                      <i className="fa fa-search" />
                      &nbsp;
                      {intl.formatMessage({ id: "search_tasks" })}
                    </ControlLabel>
                    &nbsp;
                    <NoteSearch
                      onChange={result => (this.searchNotes = result)}
                      onRef={element => (this.noteSearchComponent = element)}
                      style={{ width: "35%", display: "inline-block" }}
                      placeholder="search_tasks_placeholder"
                    />
                    {this.renderSearchResultNotes()}
                  </div>
                </div>
              </Panel>
            </Col>
          </Row>
        )}
      </div>
    );
  }

  @action
  togglePanel = () => {
    this.showPanel = !this.showPanel;
  };

  renderSearchResultNotes = () => {
    return (
      <div className="options-search-result-container centered-container">
        {this.searchNotes.map(note => (
          <div
            key={note.id}
            className="note-container"
            onClick={() => this.handleNoteResultClick(note)}
          >
            <NoteBodyText note={note} />
          </div>
        ))}
      </div>
    );
  };

  handleNoteResultClick = note => {
    const { history } = this.props;

    note.rootStore.currentNote = undefined;

    let pathname = history.location.pathname;
    pathname = pathname.replace(/\/+$/, "");

    history.push(`${pathname}/note/${note.id}`, { modal: true });
  };
}

export default injectIntl(Options);
